import {useEffect, useRef} from 'react';

/**
 * Certification-upsell helper that:
 *   1. Keeps the `onHasContent` callback stable behind a ref (so effects
 *      never go stale without needing it in their dependency arrays).
 *   2. Calls `onHasContent(false)` automatically when the upsell row unmounts.
 *
 * Returns the ref so the caller can fire the reactive notification with the
 * exact dep list it needs:
 *
 *   const onHasContentRef = useCertificationUpsellCallback(onHasContent);
 *   useEffect(() => { onHasContentRef.current?.(hasContent, ...args); }, [hasContent, ...]);
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useCertificationUpsellCallback<T extends ((...args: any[]) => void) | undefined>(
    onHasContent: T,
): React.MutableRefObject<T> {
    const ref = useRef(onHasContent);
    ref.current = onHasContent;

    useEffect(() => {
        return () => {
            ref.current?.(false);
        };
    }, []);

    return ref;
}
